import Vue from "vue";
import Vuex from "vuex";

import blogArticle from "./blogArticle.module";
import domains from "./domains.module";
import globalArticlesModule from "./globalArticles.module";
import counts from "./counts.module";
import helpArticle from "./helpArticle.module";
import invoices from "./invoices.module";
import licenses from "./licenses.module";
import product from "./product.module";
import sosTemplateArticle from "./sosTemplateArticle.module";
import supportMessages from "./supportMessages.module";
import supportTicket from "./supportTickets.module";
import user from "./user.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
		blogArticle,
		domains,
		globalArticlesModule,
		counts,
		helpArticle,
		invoices,
		licenses,
		product,
		sosTemplateArticle,
	    supportMessages,
	    supportTicket,
	    user
    }
  });
